// Bootstrap JS.
// Comment out the library you are not using.
// -----------------------------------------------------------------------------
/* eslint-disable */
import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/offcanvas';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/tab';
/* eslint-enable */
import './_tooltip-init';
import './_toast-init';
